import React from "react";
import { Box, List, ListItem, ListItemIcon, makeStyles, ListItemText, Divider, GridSize } from "@material-ui/core";
import { Grid } from "ui/grid/Grid";
import CheckCircle from "components/repairFunnel/assets/checkCircle.svg";
import IconLater from "components/repairFunnel/assets/iconLater.svg";
import IconCalendar from "components/repairFunnel/assets/iconCalendar.svg";
import IconPayezApres from "components/repairFunnel/assets/payez-apres.svg";
import ZeroRiskModal from "components/design-system/organisms/ZeroRiskModal";

interface ReassuranceItemsProps {
  repairPackagePrice?: number;
  checkItems?: string[];
  checkItemsTitle?: string;
  displayCancelInfo?: boolean;
  displayPaymentInfo?: boolean;
  timeslotText?: string;
  md?: GridSize;
}

const ReassuranceItems: React.FC<ReassuranceItemsProps> = ({
  repairPackagePrice,
  checkItems,
  checkItemsTitle,
  displayCancelInfo,
  displayPaymentInfo,
  timeslotText,
  md = 4,
}) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} md={md} className={classes.lastElement}>
      {checkItemsTitle && <div className={classes.listTitle}>{checkItemsTitle}</div>}
      <List dense>
        {checkItems?.map((item) => (
          <ListItem disableGutters key={item}>
            <ListItemIcon className={classes.circle}>
              <CheckCircle />
            </ListItemIcon>
            <ListItemText primary={item} />
          </ListItem>
        ))}
        {repairPackagePrice && (
          <ListItem disableGutters>
            <ListItemIcon className={classes.circle}>
              <CheckCircle />
            </ListItemIcon>
            <ListItemText primary="Pack zéro risque inclus" />
            <ZeroRiskModal repairPackagePrice={repairPackagePrice} />
          </ListItem>
        )}
        <Box mt={2} mb={2}>
          <Divider />
        </Box>
        {timeslotText && (
          <ListItem disableGutters>
            <ListItemIcon>
              <IconLater className={classes.icon} />
            </ListItemIcon>
            <ListItemText primary={timeslotText} />
          </ListItem>
        )}
        {displayPaymentInfo && (
          <ListItem disableGutters>
            <ListItemIcon>
              <IconPayezApres className={classes.icon} />
            </ListItemIcon>
            <ListItemText
              primary={"Payez après l'intervention"}
              secondary="Enregistrez votre carte et vous serez débités après le passage de notre réparateur"
              secondaryTypographyProps={{ className: classes.secondaryListItemText }}
            />
          </ListItem>
        )}
        {displayCancelInfo && (
          <ListItem disableGutters>
            <ListItemIcon>
              <IconCalendar className={classes.icon} />
            </ListItemIcon>
            <ListItemText
              primary="Annulation gratuite"
              secondary="jusqu'à 24h avant l'intervention"
              secondaryTypographyProps={{ className: classes.secondaryListItemText }}
            />
          </ListItem>
        )}
      </List>
    </Grid>
  );
};

export default ReassuranceItems;

const useStyles = makeStyles((theme) => ({
  listTitle: {
    fontWeight: "bold",
    fontSize: 16,
    lineHeight: "120%",
    textTransform: "uppercase",
    marginBottom: theme.spacing(2),
    color: theme.palette.secondary.main,
  },
  circle: {
    minWidth: 40,
  },
  icon: {
    maxWidth: 50,
    marginRight: theme.spacing(2),
  },
  secondaryListItemText: {
    fontSize: 13,
  },
  box: {
    [theme.breakpoints.up("sm")]: {
      whiteSpace: "nowrap",
    },
  },
  list: { padding: 0 },
  info: {
    marginTop: theme.spacing(5),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(0),
      textAlign: "center",
    },
  },
  lastElement: {
    [theme.breakpoints.down("sm")]: {
      paddingTop: "0px !important",
      paddingBottom: "60px !important",
    },
  },
}));
